// @flow
import React from "react";
import FaTrash from "react-icons/lib/fa/trash";
import {Button} from "reactstrap";
import {Dispatch} from "redux";
import {openBulkDeleteEBadgePhotoModalAction} from "../../../actions/ebadge/photo/creators/photoEBadgeActionCreator";
import {connect} from "react-redux";
import type {StoreState} from "../../../reducers/combinedReducers";

function BulkDeletePhotoButton(props) {

    return (
        <Button disabled={!props.enabled} color={"danger"} onClick={props.openModal}><FaTrash /></Button>
    )
}

function mapStateToProps(state: StoreState) {
        return {
            enabled: state.photoEBadgeAction.del.bulk.registrationCodes.length > 0
        };
}

function mapDispatchToProps(dispatch: Dispatch) {

    return {
        openModal: () => {

            dispatch(openBulkDeleteEBadgePhotoModalAction());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkDeletePhotoButton);


// WEBPACK FOOTER //
// ./src/components/ebadge/photo/BulkDeletePhotoButton.js